// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__15ZKL","percent":"style__percent__4Ye-Y","progressRing":"style__progressRing__rmlHg","circle":"style__circle__6ZSwp","circleBg":"style__circleBg__FEBmF"};